import React, { useEffect, useRef, useState } from 'react';
import { Popup } from 'devextreme-react';
import Form, { SimpleItem, GroupItem, Label, AsyncRule, StringLengthRule, RequiredRule, EmailRule } from 'devextreme-react/form';
import { useSelector, useDispatch } from 'react-redux'
import { openDialog } from '../../store/cliente/clienteDialogReducer';
import http from '../../utils/http';
import uri from '../../utils/uri';
import { defaultCliente } from '../../data/cliente';
import { formatDate } from '../../data/app';
import { createCustomStore, createStore } from '../../utils/proxy';
import { Button } from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { padIdInfo } from '../../utils/common';

const Nuevo = props => {

    const [cliente, setcliente] = useState({ ...defaultCliente });
    const [cities, setCities] = useState([]);
    const [departmentId, setDepartmentId] = useState(null);
    const [saving, setSaving] = useState({
        loading: false,
        text: 'Guardar'
    });

    const { clienteDialog, appInfo } = useSelector(store => store);
    const { id, open, editable } = clienteDialog;
    const dispatch = useDispatch();

    const onHiding = () => {
        setcliente({});
        dispatch(openDialog({ id: 0, open: false }));
    }

    const padId = padIdInfo(appInfo);


    const onShowing = (e) => {

        if (id > 0)
            http(uri.clients.getById(id)).asGet().then(c => {

                let _birthdate = moment(c.birthdate);

                if (_birthdate.isValid())
                    c.edad = moment(c.birthdate).fromNow(true).replace('years', '');

                setcliente({ ...defaultCliente, ...c, idMax: id });
            });
        else {
            http('clients/get/maxId').asGet().then(c => {

                setcliente({ ...defaultCliente, idMax: c.idMax });
            })
        }

    }

    const refForm = useRef();

    const guardarCliente = (params) => {

        let result = refForm.current.instance.validate();

        if (result.isValid) {

            setSaving({ loading: true, text: 'Guardando...' });
            http(uri.clients.insert).asPost(cliente).then(resp => {

                notify('Datos guardados correctamente');
                setSaving({ loading: false, text: 'Guardar' });
                const { onSave } = props;
                var save = onSave?.();
                onHiding();

            }).catch(err => {

                setSaving({ loading: false, text: 'Guardar' });
                notify(err, 'error');

            });

        }
    }

    useEffect(() => {
        http(`cities/get`).asGet().then(resp => setCities(resp));
    }, [0]);

    const onValueChanged = e => {
        setDepartmentId(e.value);
    }
    const onValueCiudad = e => {

        const city = cities.find(x => x.id == e.value);
        if (city)
            setcliente({ ...cliente, cityId: e.value, departmentId: city.departmentId });

    }

    const colCount = 20;
    const colSpan = colCount / 2;

    const sorted = countries => countries.sort((a, b) => a.name > b.name ? 1 : -1);

    return (
        <div>
            <Popup
                title={`Gestion de cliente`}
                width={860}
                height={720}
                onHiding={onHiding}
                onShowing={onShowing}
                visible={open}
                className="bg-fbfbfb"
            >
                <Form formData={cliente} ref={refForm} >
                    <GroupItem><div className="cleintId">No: {padId(cliente.idMax)}</div></GroupItem>
                    <GroupItem cssClass="second-group" colCount={colCount} caption={`Datos generales`}>
                        <SimpleItem dataField="name" colSpan={colSpan}
                            editorOptions={{
                                disabled: !editable
                            }} >
                            <Label text="Nombre" />
                            <RequiredRule message="Este campo es requerido" />
                            <StringLengthRule max={100} message="Maximo 100 caracteres" />
                        </SimpleItem>
                        <SimpleItem dataField="lastName" colSpan={colSpan}
                            editorOptions={{
                                disabled: !editable
                            }} >
                            <Label text="Apellidos" />
                            <RequiredRule message="Este campo es requerido" />
                            <StringLengthRule max={100} message="Maximo 100 caracteres" />
                        </SimpleItem>
                        <SimpleItem dataField="identification" colSpan={colSpan}
                            editorOptions={{
                                disabled: !editable
                            }}>
                            <RequiredRule message="Este campo es requerido" />
                            <Label text="Identificacion" />
                            <StringLengthRule max={50} message="Maximo 50 caracteres" />
                        </SimpleItem>
                        <SimpleItem dataField="professionId" editorType="dxSelectBox" colSpan={colSpan}
                            editorOptions={{
                                disabled: !editable,
                                dataSource: createStore({ name: 'profession' }),
                                valueExpr: "id",
                                displayExpr: 'name',
                            }} >
                            <Label text="Profesion" />
                            <RequiredRule message="Este campo es requerido" />
                            <StringLengthRule max={1} message="Maximo 1 caracteres" />
                        </SimpleItem>
                        <SimpleItem colSpan={7}
                            dataField="birthdate"
                            editorType="dxDateBox"
                            editorOptions={{
                                displayFormat: formatDate,
                                openOnFieldClick: true,
                                onValueChanged: e => {
                                    const edad = moment(e.value).fromNow(true).replace('years', '');
                                    setcliente({ ...cliente, edad });
                                },
                            }}>
                            <Label text="Fecha de Nac." />
                        </SimpleItem>
                        <SimpleItem colSpan={3}
                            dataField="edad"
                        >
                            <Label text="Edad" />
                        </SimpleItem>
                        <SimpleItem dataField="sexId" editorType="dxSelectBox" colSpan={colSpan}
                            editorOptions={{
                                disabled: !editable,
                                dataSource: createStore({ name: 'sex' }),
                                valueExpr: "id",
                                displayExpr: 'name',
                            }} >
                            <Label text="Sexo" />
                            <RequiredRule message="Este campo es requerido" />
                            <StringLengthRule max={1} message="Maximo 1 caracteres" />
                        </SimpleItem>

                    </GroupItem>
                    <GroupItem cssClass="second-group" colCount={4} caption="Datos de contacto">
                        <SimpleItem dataField="correo" colSpan={2}
                            editorOptions={{
                                disabled: !editable
                            }} >
                            <Label text="Correo" />
                            <EmailRule />
                            <StringLengthRule max={50} message="Maximo 50 caracteres" />
                        </SimpleItem>
                        <SimpleItem dataField="fileNumber" colSpan={2}
                            editorOptions={{
                                disabled: !editable
                            }} >
                            <Label text="Oftalmosalus " />
                            <StringLengthRule max={50} message="Maximo 50 caracteres" />
                        </SimpleItem>
                        <SimpleItem dataField="phoneNumber" colSpan={2}

                            editorOptions={{
                                disabled: !editable,
                                mask: '(999) 9999-9999',
                            }} >
                            <Label text="Telefono" />
                            <StringLengthRule max={50} message="Maximo 50 caracteres" />
                        </SimpleItem>

                        <SimpleItem dataField="cellNumber" colSpan={2}
                            editorOptions={{
                                disabled: !editable,
                                mask: '(999) 9999-9999',
                            }} >
                            <Label text="Celular" />
                            <StringLengthRule max={50} message="Maximo 50 caracteres" />
                        </SimpleItem>
                        <SimpleItem dataField="phoneNumberWork" colSpan={2}
                            editorOptions={{
                                disabled: !editable
                            }} >
                            <Label text="Tel Trabajo" />
                            <StringLengthRule max={50} message="Maximo 50 caracteres" />
                        </SimpleItem>
                        <SimpleItem dataField="nacionalityId" editorType="dxSelectBox" colSpan={2}
                            editorOptions={{
                                disabled: !editable,
                                dataSource: createCustomStore({ url: 'catalogos/Country' })(sorted),
                                valueExpr: "id",
                                displayExpr: 'name',
                                searchEnabled: true,
                                //onValueChanged: onValueChanged,
                            }} >
                            <Label text="Nacionalidad" />
                        </SimpleItem>
                        <SimpleItem dataField="departmentId" editorType="dxSelectBox" colSpan={2}
                            editorOptions={{
                                disabled: !editable,
                                dataSource: createStore({ name: 'department' }),
                                valueExpr: "id",
                                displayExpr: 'name',
                                searchEnabled: true,
                                onValueChanged: onValueChanged,
                            }} >
                            <Label text="Departamento" />
                        </SimpleItem>
                        <SimpleItem dataField="cityId" editorType="dxSelectBox" colSpan={2}
                            editorOptions={{
                                disabled: !editable,
                                dataSource: departmentId != null ? cities.filter(x => x.departmentId == departmentId) : cities, //createStore('city'),                            
                                valueExpr: "id",
                                displayExpr: 'name',
                                searchEnabled: true,
                                onValueChanged: onValueCiudad
                            }} >
                            <Label text="Ciudad" />
                        </SimpleItem>


                        <SimpleItem dataField="address"
                            colSpan={4}
                            editorOptions={{
                                disabled: !editable
                            }} >
                            <Label text="Direccion" />
                            <StringLengthRule max={250} message="Maximo 250 caracteres" />
                        </SimpleItem>
                        <SimpleItem dataField="categoryId" editorType="dxSelectBox" colSpan={2}
                            editorOptions={{
                                disabled: !editable,
                                dataSource: createStore({ name: 'category' }),
                                valueExpr: "id",
                                displayExpr: 'name',
                            }} >
                            <Label text="Categoria" />
                            <RequiredRule message="Este campo es requerido" />
                        </SimpleItem>

                        <SimpleItem dataField="active" editorType="dxSwitch" colSpan={1} editorOptions={{
                            switchedOffText: "No",
                            switchedOnText: "Si",
                        }}>
                            <Label text="Activo" />
                        </SimpleItem>
                        <SimpleItem dataField="sendNotification" editorType="dxSwitch" colSpan={1} editorOptions={{
                            switchedOffText: "No",
                            switchedOnText: "Si",
                        }}>
                            <Label text="SMS de cumpleaños?" />
                        </SimpleItem>
                        <SimpleItem dataField="observation"
                            colSpan={4}
                            editorOptions={{
                                disabled: !editable
                            }} >
                            <Label text="Observación" />
                            <StringLengthRule max={500} message="Maximo 500 caracteres" />
                        </SimpleItem>
                    </GroupItem>
                </Form>
                <Button
                    width={180}
                    text={saving.text}
                    disabled={saving.loading}
                    type="default"
                    icon='save'
                    onClick={guardarCliente}
                />
                <br />
            </Popup>
        </div>
    );
}

export default Nuevo;
